import React from "react";
import { View, StyleSheet } from "react-native";

import { Icon, Cover, Button, Text } from "components";
import StepChanger from "./StepChanger";

import tinycolor from "tinycolor2";
import { sizes, colors, strings } from "assets/constants";
import { useChangeStepFlags } from "./hooks/useChangeStepFlags";

type PropsT = {
  onClose: () => void;
  onChangeTargetStep: (step: FactorStatusT) => void;
  defaultStepPriority: number;
  hideStepChanger?: boolean;
};

const ItemsSectionTitle: React.FC<PropsT> = (props) => {
  const { hideStepChanger, onClose, onChangeTargetStep, defaultStepPriority } =
    props;

  const {
    multiItemsChangeStepMode,
    goToMultiItemsChangeStepMode,
    singleItemChangeStepModeForAll,
  } = useChangeStepFlags();

  const _renderLeftSection = () => {
    if (multiItemsChangeStepMode) {
      return (
        <>
          <Button
            onPress={onClose}
            square={37}
            icon={{ name: "x", size: 25, color: colors.danger }}
            bgColor={colors.transparent}
            bordered={{
              width: 1,
              color: tinycolor(colors.danger).lighten(25).toString(),
            }}
          />

          <View
            style={{
              borderRadius: sizes.radius.lg,
              marginLeft: sizes.space,
              borderWidth: 1,
              borderColor: tinycolor(colors.theme).lighten(45).toString(),
            }}
          >
            <StepChanger
              defaultStepPriority={defaultStepPriority}
              onChange={onChangeTargetStep}
            />
          </View>
        </>
      );
    }

    if (singleItemChangeStepModeForAll) {
      return (
        <Button
          onPress={onClose}
          bgColor={tinycolor(colors.danger).lighten(40).toString()}
          height={37}
          width={115}
          title={{
            weight: "bold",
            color: colors.danger,
            value: strings.clear + " " + strings.all,
          }}
        />
      );
    }

    return (
      <Button
        onPress={goToMultiItemsChangeStepMode}
        height={37}
        width={100}
        title={{
          value: strings.group_replace,
          weight: "bold",
          color: colors.theme,
        }}
        bgColor={tinycolor(colors.theme).lighten(48).toString()}
      />
    );
  };

  return (
    <View style={[styles.row, styles.container]}>
      {hideStepChanger ? <></> : _renderLeftSection()}

      <Cover />
      <View style={styles.row}>
        <Text weight="bold" size={"xl"}>
          {strings.products}
        </Text>
        <Icon style={{ marginLeft: 5 }} name={"box"} size={25} />
      </View>
    </View>
  );
};

export default ItemsSectionTitle;

const styles = StyleSheet.create({
  container: { height: 55 },

  row: { flexDirection: "row", alignItems: "center" },
});
